var _path, _rect, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionTypeIbGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6296 3.77809L20.9921 3.14568C20.6138 2.78246 20.1646 2.49433 19.6703 2.29776C19.176 2.10118 18.6462 2 18.1111 2C17.576 2 17.0462 2.10118 16.5519 2.29776C16.0576 2.49433 15.6084 2.78246 15.2301 3.14568L12.1084 6.16286C12.039 6.22953 12 6.31992 12 6.41418C12 6.50843 12.039 6.59883 12.1084 6.6655L13.4352 7.94054C13.5047 8.00717 13.5988 8.04459 13.697 8.04459C13.7952 8.04459 13.8894 8.00717 13.9588 7.94054L15.7037 6.26685L20.4101 10.7848C20.4796 10.8515 20.5738 10.8889 20.6719 10.8889C20.7701 10.8889 20.8643 10.8515 20.9337 10.7848L21.8916 9.86666C21.961 9.79999 22 9.7096 22 9.61534C22 9.52109 21.961 9.43069 21.8916 9.36402L17.1852 4.8447L19.7879 2.34617",
    stroke: "#575757",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 10.8889,
    width: 12,
    height: 11,
    rx: 3,
    stroke: "#575757",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 16.8889L10 14.4417L8 13.9522L9.97911 10.8889",
    stroke: "#575757",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionTypeIbGrey);
export default __webpack_public_path__ + "static/media/question_type_ib_grey.f00dd5ea1cc109eab96a08b067f05fd6.svg";
export { ForwardRef as ReactComponent };